// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserTrainingForm__wrapper__1j_UY","submitResult":"SettingsUserTrainingForm__submitResult__1T7Wq","actionWrapper":"SettingsUserTrainingForm__actionWrapper__wLOzM","wrapper2faOptions":"SettingsUserTrainingForm__wrapper2faOptions__20i_l","formItem":"SettingsUserTrainingForm__formItem__1rGl9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsUserTrainingForm/SettingsUserTrainingForm.css
// module id = 1869
// module chunks = 0